import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-503a665e")

_pushScopeId("data-v-503a665e")
const _hoisted_1 = {
  class: "page",
  style: {"padding-bottom":"12px"}
}
const _hoisted_2 = /*#__PURE__*/_createVNode("p", null, "智能床", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("p", null, "太空椅", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", null, "其他", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")
  const _component_van_cell = _resolveComponent("van-cell")
  const _component_van_list = _resolveComponent("van-list")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, { title: "说明视频" }),
    _hoisted_2,
    _createVNode(_component_van_list, { class: "card" }, {
      default: _withId(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.bedList, (item) => {
          return (_openBlock(), _createBlock(_component_van_cell, {
            key: item.key,
            title: item.name,
            onClick: $event => (_ctx.$router.push(`/instructionalVideo/${item.key}`))
          }, null, 8, ["title", "onClick"]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _: 1
    }),
    _hoisted_3,
    _createVNode(_component_van_list, { class: "card" }, {
      default: _withId(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.chairList, (item) => {
          return (_openBlock(), _createBlock(_component_van_cell, {
            key: item.key,
            title: item.name,
            onClick: $event => (_ctx.$router.push(`/instructionalVideo/${item.key}`))
          }, null, 8, ["title", "onClick"]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _: 1
    }),
    _hoisted_4,
    _createVNode(_component_van_list, { class: "card" }, {
      default: _withId(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.otherList, (item) => {
          return (_openBlock(), _createBlock(_component_van_cell, {
            key: item.key,
            title: item.name,
            onClick: $event => (_ctx.$router.push(`/instructionalVideo/${item.key}`))
          }, null, 8, ["title", "onClick"]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _: 1
    })
  ]))
})